import script from "./ConsumerMypageResetPasswordView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumerMypageResetPasswordView.vue?vue&type=script&setup=true&lang=js"

import "./ConsumerMypageResetPasswordView.vue?vue&type=style&index=0&id=0c1df436&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c1df436"]])

export default __exports__